export class EstateBankingRoute {
  static BANKING_REQUESTS = {
    path: 'estate-banking-requests',
    name: 'estate-banking-requests'
  };
}
